import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import Tables from "layouts/tables";
import { useEffect, useState } from "react";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useDeleteAddOnStockMutation } from "slices/beautyApp/addOnStockSlice";
import { useSelector } from "react-redux";
import { hasActionAccess } from "utility";
import { useGetSubscriptionsQuery } from "slices/beautyApp/subscriptionSlice";

function Subscriptions() {
  const naviagte = useNavigate();
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const auth = useSelector((state) => state.auth?.auth?.user);
  const [del] = useDeleteAddOnStockMutation();

  const { data, isLoading, refetch } = useGetSubscriptionsQuery({
    page,
    limit,
    search,
  });

  useEffect(() => {
    console.log("API called with params:", { page, limit, search });
  }, [page, limit, search]);

  const col = [
    { display: "Name", key: "name", type: "display" },
    { display: "Description", key: "description", type: "display" },
    { display: "Top-Up-Period", key: "topUpPeriod", type: "display" },
  ];

  const canEdit = hasActionAccess(auth, "Beauty App", "Subscriptions", "view");
  const canDelete = hasActionAccess(
    auth,
    "Beauty App",
    "Add on Stock",
    "delete"
  );

  if (canEdit || canDelete) {
    col.push({
      display: "Actions",
      key: "edit",
      type: "action",
      render: (row, onEdit, handleDelete) => (
        <>
          {canEdit && <Button onClick={() => onEdit(row)}>Edit</Button>}
          {/* {canDelete && (
            <Button onClick={() => handleDelete(row._id)}>Delete</Button>
          )} */}
        </>
      ),
    });
  }

  const handleSearchChange = (value) => {
    setSearch(value);
    setPage(1);
  };

  const changePage = (newPage, newLimit) => {
    const apiPage = newPage + 1; // MUI is 0-based, API is 1-based
    setPage(apiPage);
    setLimit(newLimit);
  };

  const onEdit = (row) => {
    naviagte(`/beauty-app/subscriptions/update-plan/${row._id}`, {
      state: { refresh: true },
    });
  };

  const handleAdd = () => {
    naviagte("/beauty-app/subscriptions/add-plan", {
      state: { refresh: true },
    });
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this plan?")) {
      await del(id).unwrap();
      refetch();
    }
  };

  const onTabClick = (index, item) => {
    // if (index === 0) {
    //   setType("");
    // } else {
    //   setType(item.value);
    // }
    // refetch();
  };
  const canAdd = hasActionAccess(auth, "Beauty App", "Subscriptons", "add");

  return (
    <DashboardLayout>
      <DashboardNavbar />

      {canAdd && (
        <Button onClick={handleAdd} style={{ background: "#fff" }}>
          Add New Plan
        </Button>
      )}
      <Tables
        tabs={[]}
        title={"Beautician Subscriptions"}
        handleSearch={handleSearchChange}
        totalPages={data?.totalPages}
        data={data?.data}
        columns={col}
        changePage={changePage}
        onEdit={onEdit}
        handleDelete={handleDelete}
        onTabClick={onTabClick}
        currentPage={page}
        rowsPerPage={limit}
      />
      <Footer />
    </DashboardLayout>
  );
}

export default Subscriptions;
